import { render, staticRenderFns } from "./Game9_tyt.vue?vue&type=template&id=138c86d2&scoped=true&"
import script from "./Game9_tyt.vue?vue&type=script&lang=js&"
export * from "./Game9_tyt.vue?vue&type=script&lang=js&"
import style0 from "./Game9_tyt.vue?vue&type=style&index=0&id=138c86d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138c86d2",
  null
  
)

export default component.exports